import { CopyIcon } from '@p2p/assets/svg';
import { CopyText } from '@p2p/components';
import { FC } from 'react';

import styles from '../../styles.module.scss';

type InfoBlockProps = {
  value: string;
  copyValue?: string;
};

export const InfoBlock: FC<InfoBlockProps> = ({ value, copyValue }) => {
  return (
    <div className={styles.input_field__wr}>
      <input type="text" className={styles.input_field__input} value={value} disabled />
      <CopyText text={copyValue || value}>
        <div className={styles.input_field__copy}>
          <CopyIcon />
        </div>
      </CopyText>
    </div>
  );
};
